export const applyTextColor = (color) => {
  document.execCommand("foreColor", false, color);
};

export const wrapSelectionInSpan = ({
  color,
  baseModel,
  doc
}) => {
  if (!color || !baseModel || !doc) {
    return doc;
  }

  const { anchor, focus } = baseModel;
  if (!anchor || !focus) {
    return doc;
  }

  const result = splitSelectionToSpan({
    doc: doc,
    baseModel,
    color
  });

  return result
};

export const splitSelectionToSpan = ({ doc, baseModel, color }) => {

  if (!doc || !baseModel) {
    return
  }

  const result = wrapSelectionAcrossNodes({ doc, baseModel, color })
  return result
}

export const wrapSelectionAcrossNodes = ({ doc, baseModel, color }) => {
  if (!Array.isArray(doc) || !baseModel) {
    return doc;
  }

  const { anchor, focus } = baseModel;
  if (!anchor || !focus) {
    return doc;
  }

  const newDoc = structuredClone(doc);

  // normalize selection
  const start =
    comparePath(anchor.path, focus.path) <= 0 ? anchor : focus;
  const end = start === anchor ? focus : anchor;

  // collect all text nodes
  const textNodes = [];
  newDoc.forEach((block, blockIndex) => {
    collectTextNodes(block, [blockIndex], textNodes);
  });
  // loop ngược để tránh lệch index
  textNodes.reverse().forEach(({ node, path }) => {
    const isAfterStart = comparePath(path, start.path) >= 0;
    const isBeforeEnd = comparePath(path, end.path) <= 0;

    if (!isAfterStart || !isBeforeEnd) {
      return;
    }

    const parentPath = path.slice(0, -1);
    const index = path[path.length - 1];

    const parent = getNodeByPath(newDoc, parentPath);
    if (!parent) {
      return;
    }

    const text = node.content;

    let sliceStart = 0;
    let sliceEnd = text.length;

    if (isSamePath(path, start.path)) {
      sliceStart = start.offset;
    }

    if (isSamePath(path, end.path)) {
      sliceEnd = end.offset;
    }

    if (sliceStart === sliceEnd) {
      return;
    }

    const before = text.slice(0, sliceStart);
    const selected = text.slice(sliceStart, sliceEnd);
    const after = text.slice(sliceEnd);
    const newNodes = [];

    if (before) newNodes.push({ type: "text", content: before });

    if (selected) {
      newNodes.push({
        type: "span",
        attributes: {
          style: `color: ${color}`
        },
        children: [{ type: "text", content: selected }]
      });
    }

    if (after) newNodes.push({ type: "text", content: after });

    parent.children.splice(index, 1, ...newNodes);
  });

  return newDoc;
};

const collectTextNodes = (node, path, result) => {
  if (node.type === "text") {
    result.push({ node, path });
    return;
  }

  if (!node.children) return;

  node.children.forEach((child, i) => {
    collectTextNodes(child, [...path, i], result);
  });
};

const getNodeByPath = (rootArray, path) => {
  let node = rootArray[path[0]];

  for (let i = 1; i < path.length; i++) {
    if (!node.children || node.children[path[i]] == null) {
      return null;
    }
    node = node.children[path[i]];
  }

  return node;
};

const isSamePath = (a, b) =>
  a.length === b.length && a.every((v, i) => v === b[i]);

const comparePath = (a, b) => {
  for (let i = 0; i < Math.min(a.length, b.length); i++) {
    if (a[i] !== b[i]) return a[i] - b[i];
  }
  return a.length - b.length;
};

export const getCurrentTextColor = () => {
  if (typeof window === "undefined") return "#000000";

  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) {
    return "#000000";
  }

  const range = selection.getRangeAt(0);

  let container = range.commonAncestorContainer;

  if (container.nodeType === Node.TEXT_NODE) {
    container = container.parentElement;
  }

  if (!container) {
    return "#000000";
  }

  let element = container;
  let depth = 0;

  // Walk up the DOM tree to find color style
  while (element && element.nodeType === Node.ELEMENT_NODE && depth < 10) {
    depth++;
    if (element.style && element.style.color) {
      const inlineColor = element.style.color;
      const hex = rgbToHex(inlineColor);
      return hex;
    }

    // Check for style attribute with color property
    const styleAttr = element.getAttribute('style');
    if (styleAttr && styleAttr.includes('color:')) {
      const colorMatch = styleAttr.match(/color:\s*([^;]+)/);
      if (colorMatch) {
        const color = colorMatch[1].trim();
        const hex = rgbToHex(color);
        return hex;
      }
    }

    // Check computed style
    const computedColor = window.getComputedStyle(element).color;
    if (computedColor && computedColor !== "rgb(0, 0, 0)" && computedColor !== "rgba(0, 0, 0, 0)") {
      const hex = rgbToHex(computedColor);
      return hex;
    }

    element = element.parentElement;
  }

  if (container) return `#${range.startContainer?.attributes?.style?.value.split('#')?.[1]}`

};

const rgbToHex = (rgb) => {
  if (rgb.startsWith("#")) {
    return rgb;
  }

  const match = rgb.match(/\d+/g);
  if (!match) {
    return "#000000";
  }

  const r = parseInt(match[0]);
  const g = parseInt(match[1]);
  const b = parseInt(match[2]);

  const hex = "#" +
    [r, g, b]
      .map((x) => {
        const hexValue = x.toString(16);
        return hexValue.length === 1 ? "0" + hexValue : hexValue;
      })
      .join("")
      .toLowerCase();

  return hex;
};
